<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">CANTIDAD DE PERSONAS REGISTRADAS</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="fecha_reg">Fecha de registro</label>
              <input
                type="date"
                class="form-control"
                id="fecha_reg"
                v-model="fecha_reg"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="tipo_persona">Tipo de persona</label>
              <select
                class="form-control"
                id="tipo_persona"
                v-model="tipo_persona"
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
          <div class="col">
            <button
              class="btn btn-info mt-4"
              type="button"
              @click="getPersona(tipo_persona, fecha_reg)"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div class="pt-5">
          <div
            class="alert alert-primary"
            role="alert"
            v-for="persona in personas"
            :key="persona.id"
          >
            cantidad de extrangeros: {{ persona.total }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      personas: {},
      tipo_persona: 0, //3
      fecha_reg: "", //"2021-12-31",
    };
  },
  methods: {
    async getPersona(tipo_persona, fecha_reg) {
      try {
        let res = await this.axios.get(
          `/reportesbusqueda/${tipo_persona}/${fecha_reg}`
        );
        this.personas = res.data.contenido;
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
  },
};
</script>
